import type { ScoutPackage } from "generated-graphql/graphql";

import { useQuery } from "@apollo/client";
import { gql } from "generated-graphql";
import { useTenantId } from "hooks/useTenant";

export const SCOUT_ACCESS_QUERY = gql(`
  query ScoutAccess($tenantId: ID!) {
    scoutAccess(tenantId: $tenantId) {
      package
      proCreditsRemaining
    }
  }
`);

/**
 * The server's resolved Scout access for the current user, which accounts for
 * Scout Pro preview credits. Null until loaded, or when skipped.
 */
export function useServerScoutAccess(skip: boolean): {
  scoutPackage: ScoutPackage | null;
  loading: boolean;
} {
  const tenantId = useTenantId();
  const { data, loading } = useQuery(SCOUT_ACCESS_QUERY, {
    variables: { tenantId: tenantId ?? "" },
    skip: skip || !tenantId,
  });
  return { scoutPackage: data?.scoutAccess.package ?? null, loading };
}
